import { render, staticRenderFns } from "./VaIconSlower.vue?vue&type=template&id=356dc39b&"
import script from "./VaIconSlower.vue?vue&type=script&lang=js&"
export * from "./VaIconSlower.vue?vue&type=script&lang=js&"
import style0 from "./VaIconSlower.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports